import { API } from 'api';
import { AxiosResponse } from 'axios';
import { IUtilityMapStatus } from 'types';
import type { UtilityMapProcessName } from 'utils/helpers';
import { API_URL } from 'utils/enums';

const DEVICE_FP = '6037e65eefbdasdfadsfasdf3';

class UtilityMapService {
	static getStatus = async (): Promise<AxiosResponse<IUtilityMapStatus>> =>
		API.post(API_URL.UNDEFINED_PROVIDER_DATA_STATUS, {
			deviceFP: DEVICE_FP,
		});

	static resetStatus = async (keys: UtilityMapProcessName[]): Promise<AxiosResponse<string>> =>
		API.post(API_URL.UNDEFINED_PROVIDER_DATA_RESET, {
			keys,
		});
}

export { UtilityMapService };
